module.exports = __webpack_public_path__ + "img/ThankYou.f7c7bfbc.png";